module.exports = __webpack_public_path__ + "static/shul_Quality-4d1af8a9061565bfc73cc6f53317f282.jpg";